// $('.mobile-menu>nav>ul').slick({
//   dots: false,
//   arrows: false,
//   cssEase: 'ease',
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 3,
//   infinite: true,
  
// });

$('.mobile-menu>nav>ul').owlCarousel({
    loop:false,
    stagePadding: -20,
    responsive:{
        0:{
            items:2,
            nav:false,
            dots:false
        },
        300:{
            items:4,
            nav:false,
            dots:false
        },
        450:{
            items:4,
            nav:false,
            dots:false
        },
        600:{
            items:4,
            nav:false,
            dots:false          
        },
        1000:{
            items:4,
            nav:false,
            dots:false          
        }
    }
})

//Sub-menu for mobile 

var mobileMenuItems = document.querySelectorAll('.mobile-menu nav ul site-nav--has-dropdown ');

mobileMenuItems.forEach(function(item) {
  var mSubmenu = item.querySelector('.site-nav__dropdown ');
  
  if (mSubmenu) {
    item.addEventListener('click', function() {
      mSubmenu.classList.toggle('visible');
    });
  }
});

     setTimeout(function() {
       if (window.KOSMApp) {
               window.KOSMApp.listenForInputChange();
       }
     }, 100);
